module.exports = __webpack_public_path__ + "static/img/memberXB.a6c3756.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberXB.png
// module id = cQHP
// module chunks = 0